export default __webpack_public_path__ + "static/media/Armwraps of the Forsaken.e6665e1b.jpg";